import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type TermoDefinicaoPrazoPjJob = ReportJob;
export type TermoDefinicaoPrazoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Termo de Definição de Prazo PJ. */
@Injectable({ providedIn: 'root' })
export class TermoDefinicaoPrazoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'termo-definicao-prazo-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.termoDefinicaoPrazoPj;
}
